import { Price } from '@shared/models/price.model';
import { SubscriptionOffering } from '@shared/models/subscription-offering.model';

export class MbbDataInfo {
  dataOnNet?: number;
  hasRollover: boolean;
}

export class MbbAllowedChangeInfo {
  changeInfo: MbbChangeInfo;
  subscriptionOffering: MbbSubscriptionOffering;
}
export class MbbChangeInfo {
  triggersBreakageFee: boolean;
  remainingBreakageFee: Price;
}

export class MbbSubscriptionOffering extends SubscriptionOffering {
  dataInfo: MbbDataInfo;
}

export interface Image {
  id: string;
  downloadUri: string;
  previewUri: string;
  name: string;
  description: string;
  fileName: string;
  contentType: string;
  labels: string[];
}

export class BindingInformation {
  breakageFee: Price;
  bindingPeriodInMonths: number;
}

export class Bundle {
  offeringId: string;
  subscriptionOfferingId: string;
  subsidyId: string;
  name: string;
  monthlySubscriptionPriceInfo: Price;
  hardwarePrice: Price;
  discountLengthMonths: number;
}

export class MbbRouter {
  offeringId: string;
  name: string;
  gtin: string;
  image: Image;
  bundles: Bundle[];
  productAvailability: string;
  isBackorderEnabled: boolean;
  externalRetailOnly: boolean;
  stock: number;
}
